import { Group, Pagination as MantinePagination, Select, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

export interface Props {
  page: number;
  limit: number;
  total: number;
  onChange?: (_page: number) => void;
  onLimitChange?: (_limit: number) => void;
}

const Pagination = ({ page, limit, total, onChange, onLimitChange }: Props) => {
  const { t } = useTranslation();
  const from = limit * (page - 1) + 1;
  const to = Math.min(total, limit * page);
  const message = t("common.showingPagination", { from, to, total });

  return (
    <Group justify="space-between" gap="md">
      <Text size="sm">{message}</Text>
      <Group gap="sm">
        {onLimitChange && (
          <Select
            size="xs"
            data={[
              { value: "10", label: t("common.perPage", { count: 10 }) },
              { value: "25", label: t("common.perPage", { count: 25 }) },
              { value: "50", label: t("common.perPage", { count: 50 }) },
              { value: "100", label: t("common.perPage", { count: 100 }) },
            ]}
            value={limit.toString()}
            onChange={(value) => {
              if (value) {
                onLimitChange(parseInt(value));
              }
            }}
            w={140}
          />
        )}
        <MantinePagination
          total={Math.ceil(total / limit)}
          value={page}
          onChange={onChange}
          withPages={false}
        />
      </Group>
    </Group>
  );
};

export default Pagination;
